import { connect } from 'react-redux';
import { fetchUserModelAction } from '@helpCenter/epics/model/user';
import Header from './header';

export default connect(null, {
    fetchUser: fetchUserModelAction,
})(Header);
